import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { useVersionCheck } from 'src/hooks/use-version-check';

export function NewVersionBanner() {
  const isOutdated = useVersionCheck();

  if (!isOutdated) return null;

  return (
    <Alert
      severity="info"
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 100000,
        borderRadius: 0,
        justifyContent: 'center',
      }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>
      }
    >
      A new version is available. All your changes have been saved. (v3)
    </Alert>
  );
}
